// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bottom-stack {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-shrink: 0;
}

.chat-overlay-stack {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  pointer-events: none;
  padding: 0 1.5rem;
}

.chat-overlay-stack--mode-collapsed {
  gap: 0;
}

.chat-overlay-stack--consent-active {
  gap: 0.45rem;
}

.composer-limit-warning {
  pointer-events: none;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  border: 1px solid rgba(239, 68, 68, 0.42);
  background: rgba(254, 226, 226, 0.96);
  color: #b91c1c;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow:
    0 0 0 2px rgba(239, 68, 68, 0.12),
    0 8px 20px rgba(239, 68, 68, 0.16);
}

.dark .composer-limit-warning {
  border-color: rgba(248, 113, 113, 0.42);
  background: rgba(76, 29, 29, 0.96);
  color: #fecaca;
  box-shadow:
    0 0 0 2px rgba(248, 113, 113, 0.12),
    0 8px 20px rgba(0, 0, 0, 0.3);
}

.llm-pause-container {
  pointer-events: none;
  transform: translateY(-1.55rem);
}

.llm-pause-container--mode-collapsed {
  transform: translateY(-0.95rem);
}

.App.App--single-column .llm-pause-container {
  transform: translateY(0.8rem);
}

.App.App--single-column .llm-pause-container--mode-collapsed {
  transform: translateY(1.1rem);
}

.llm-pause-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 1.05rem;
  background: #ffffff;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
}

.dark .llm-pause-btn {
  background: #111827;
  border-color: #374151;
  color: #f9fafb;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
}

.llm-pause-btn:hover {
  background: #eff6ff;
  border-color: #3b82f6;
  color: #1d4ed8;
  transform: translateY(-1px);
}

.dark .llm-pause-btn:hover {
  background: #1e3a8a;
  border-color: #3b82f6;
  color: #e5e7eb;
}

.llm-pause-btn:active {
  transform: translateY(0);
}

.llm-pause-btn.paused {
  background: #10b981;
  color: #ffffff;
  border-color: #059669;
}

.llm-pause-btn.paused:hover {
  background: #059669;
  transform: translateY(-1px);
}

.pause-icon {
  width: 0.95rem;
  height: 0.95rem;
  flex: 0 0 auto;
  display: block;
}

.pause-text {
  font-size: 0.85rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.chat-input-container {
  position: relative;
  z-index: 11;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  background: var(--surface-color);
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.chat-input-container.disabled-preview {
  opacity: 0.4;
  pointer-events: none;
}

.dark .chat-input-container {
  border-top-color: #374151;
  background: #1f2937;
}

.chat-input {
  flex: 1 1;
  min-width: 0;
  max-width: 100%;
  padding: 0.875rem 1.25rem;
  font-size: 0.95rem;
  line-height: 1.5;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  outline: none;
  transition: all 0.2s ease;
  font-family: inherit;
  background: var(--surface-color);
  color: #1f2937;
  resize: none;
  overflow-y: hidden;
  overflow-x: hidden;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.dark .chat-input {
  background: #374151;
  color: #f9fafb;
}

.chat-input::placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-input:focus,
.dark .chat-input:focus {
  box-shadow: none;
}

.chat-input:disabled {
  background-color: transparent;
  cursor: not-allowed;
}

.dark .chat-input:disabled {
  background-color: transparent;
  color: #6b7280;
}

.chat-input-shell {
  flex: 1 1;
  min-width: 0;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 48px;
  padding: 0 0.35rem 0 0;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  background: var(--surface-color);
  transition: all 0.2s ease;
}

.chat-input-shell--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.dark .chat-input-shell {
  background: #374151;
  border-color: #4b5563;
}

.dark .chat-input-shell--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.chat-input-shell--limit-flash {
  border-color: #ef4444;
  background: #fee2e2;
  box-shadow:
    0 0 0 3px rgba(239, 68, 68, 0.24),
    0 0 24px rgba(239, 68, 68, 0.22);
}

.dark .chat-input-shell--limit-flash {
  border-color: #f87171;
  background: #4c1d1d;
  box-shadow:
    0 0 0 3px rgba(248, 113, 113, 0.24),
    0 0 24px rgba(248, 113, 113, 0.2);
}

.chat-input-shell:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.chat-input-shell--selection-cue:focus-within {
  border-color: #2563eb;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.5),
    0 0 34px rgba(59, 130, 246, 0.9);
}

.dark .chat-input-shell:focus-within {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.2);
}

.dark .chat-input-shell--selection-cue:focus-within {
  border-color: #93c5fd;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.38),
    0 0 32px rgba(96, 165, 250, 0.56);
}

.chat-input-shell--limit-flash:focus-within {
  border-color: #dc2626;
  box-shadow:
    0 0 0 3px rgba(239, 68, 68, 0.28),
    0 0 28px rgba(239, 68, 68, 0.24);
}

.dark .chat-input-shell--limit-flash:focus-within {
  border-color: #fca5a5;
  box-shadow:
    0 0 0 3px rgba(248, 113, 113, 0.28),
    0 0 28px rgba(248, 113, 113, 0.22);
}

.chat-input-shell:has(.chat-input:disabled) {
  background-color: #f9fafb;
}

.dark .chat-input-shell:has(.chat-input:disabled) {
  background-color: #374151;
}

.chat-input-shell .chat-input {
  border: none;
  border-radius: 18px;
  background: transparent;
  min-width: 0;
  width: 100%;
  min-height: 1.5em;
  max-height: calc(1.5em * 3 + 1.75rem);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

.keyboard-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 36px;
  align-self: center;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: var(--surface-color);
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dark .keyboard-btn {
  background: #374151;
  border-color: #4b5563;
  color: #d1d5db;
}

.keyboard-btn:hover {
  transform: translateY(-1px);
  background: #f3f4f6;
  border-color: #94a3b8;
}

.dark .keyboard-btn:hover {
  background: #4b5563;
  border-color: #6b7280;
}

.keyboard-btn:disabled {
  cursor: not-allowed;
  opacity: 1;
  transform: none;
  background: #f9fafb;
  border-color: #d1d5db;
  color: #9ca3af;
}

.keyboard-btn:disabled:hover {
  transform: none;
  background: #f9fafb;
  border-color: #d1d5db;
}

.dark .keyboard-btn:disabled {
  background: #374151;
  border-color: #4b5563;
  color: #6b7280;
}

.dark .keyboard-btn:disabled:hover {
  background: #374151;
  border-color: #4b5563;
}

.keyboard-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);
}

.keyboard-icon {
  width: 16px;
  height: 16px;
}

.send-btn {
  padding: 0.875rem 2rem;
  min-height: 48px;
  align-self: center;
  background: #2563eb;
  color: #f0f9ff;
  border: 1px solid #1d4ed8;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  box-shadow: none;
}

.dark .send-btn {
  background: #2563eb;
  border-color: #1e3a8a;
  color: #e0f2fe;
  box-shadow: none;
}

.send-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: none;
}

.dark .send-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: none;
}

.send-btn:disabled {
  background: #cbd5f5;
  border-color: #b4c3f0;
  color: #6b7280;
  cursor: not-allowed;
  box-shadow: none;
}

.dark .send-btn:disabled {
  background: #1f2937;
  border-color: #374151;
  color: #4b5563;
}

.send-icon {
  display: block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  fill: currentColor;
  transition: transform 0.2s ease;
}

.send-btn:hover:not(:disabled) .send-icon {
  transform: translateX(2px);
}

.send-btn--compact-inside {
  display: none;
}

@media (max-width: 1067px) {
  .keyboard-btn {
    display: none;
  }

  .send-btn--desktop {
    display: none;
  }

  .send-btn--compact-inside {
    display: inline-flex;
    flex: 0 0 auto;
    width: 34px;
    height: 34px;
    min-height: 34px;
    padding: 0;
    border-radius: 18px;
    align-self: center;
  }

  .send-btn--compact-inside .send-icon {
    width: 15px;
    height: 15px;
  }

  .send-btn--compact-inside:hover:not(:disabled) {
    transform: none;
  }

  .send-btn--compact-inside:hover:not(:disabled) .send-icon {
    transform: translateX(1px);
  }
}

.App.App--single-column .chat-input-container {
  padding: 0.475rem 0.9rem;
  gap: 0.55rem;
}

.App.App--single-column .chat-input-shell {
  min-height: 40px;
  border-radius: 20px;
}

.App.App--single-column .chat-input-shell .chat-input {
  font-size: 16px;
  padding-top: 0.56rem;
  padding-bottom: 0.56rem;
  line-height: 1.42;
}

.App.App--single-column .session-controls-compact__trigger {
  height: 40px;
}

.App.App--single-column .send-btn--compact-inside {
  width: 30px;
  height: 30px;
  min-height: 30px;
}

.App.App--single-column .send-btn--compact-inside .send-icon {
  width: 14px;
  height: 14px;
}

.session-controls-compact {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.session-controls-compact__trigger {
  width: 1rem;
  min-width: 1rem;
  height: 48px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #64748b;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.18rem;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.session-controls-compact__trigger:hover {
  background: transparent;
  border-color: transparent;
  color: #334155;
}

.session-controls-compact__dot {
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: currentColor;
}

.session-controls-compact__menu {
  position: absolute;
  left: 0;
  bottom: calc(100% + 0.45rem);
  width: 10.5rem;
  overflow: hidden;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: var(--surface-color);
  box-shadow: none;
  z-index: 30;
}

.session-controls-compact__item {
  width: 100%;
  border: 0;
  background: transparent;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.62rem 0.75rem;
  font-family: inherit;
  font-size: 0.84rem;
  font-weight: 650;
  text-align: left;
}

.session-controls-compact__item .control-icon {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.session-controls-compact__item:hover:not(:disabled),
.session-controls-compact__item.active {
  background: #f3f4f6;
  color: #111827;
}

.session-controls-compact__item:disabled {
  color: #9ca3af;
  cursor: not-allowed;
}

.dark .session-controls-compact__trigger {
  background: transparent;
  border-color: transparent;
  color: #94a3b8;
}

.dark .session-controls-compact__trigger:hover {
  background: transparent;
  border-color: transparent;
  color: #e2e8f0;
}

.dark .session-controls-compact__menu {
  background: #1f2937;
  border-color: #4b5563;
}

.dark .session-controls-compact__item {
  color: #d1d5db;
}

.dark .session-controls-compact__item:hover:not(:disabled),
.dark .session-controls-compact__item.active {
  background: #374151;
  color: #f9fafb;
}

.dark .session-controls-compact__item:disabled {
  color: #6b7280;
}

.session-control-btn {
  padding: 0.875rem 1rem;
  background: #e5e7eb;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 20px;
  font-size: 1.25rem;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
}

.dark .session-control-btn {
  background: #374151;
  color: #f9fafb;
  border-color: #4b5563;
}

.session-control-btn:hover:not(:disabled) {
  background: #cbd5e1;
  border-color: #94a3b8;
}

.dark .session-control-btn:hover:not(:disabled) {
  background: #4b5563;
  border-color: #6b7280;
}

.session-control-btn:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.5;
}

.dark .session-control-btn:disabled {
  background: #1f2937;
  color: #4b5563;
  border-color: #374151;
}

.control-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
  transition: transform 0.2s ease;
}

.session-control-btn:hover:not(:disabled) .control-icon {
  transform: translateY(-1px);
}

.consent-container {
  pointer-events: none;
  width: auto;
  display: flex;
  justify-content: center;
  transform: translateY(-0.35rem);
}

.consent-panel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.85rem;
  background: #ffffff;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
  pointer-events: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
  white-space: nowrap;
}

.dark .consent-panel {
  background: #111827;
  border-color: #374151;
  color: #f9fafb;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);
}

.consent-panel--selection-cue {
  border-color: #3b82f6;
  background: #dbeafe;
  box-shadow:
    0 0 0 3px rgba(59, 130, 246, 0.42),
    0 0 30px rgba(59, 130, 246, 0.82);
}

.dark .consent-panel--selection-cue {
  border-color: #60a5fa;
  background: #1e3a5f;
  box-shadow:
    0 0 0 3px rgba(96, 165, 250, 0.3),
    0 0 28px rgba(96, 165, 250, 0.44);
}

.consent-label {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #6b7280;
}

.dark .consent-label {
  color: #9ca3af;
}

.consent-divider {
  width: 1px;
  height: 1.1rem;
  background: #e5e7eb;
  margin: 0 0.25rem;
}

.dark .consent-divider {
  background: #374151;
}

.consent-btn {
  padding: 0.3rem 0.85rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
  letter-spacing: 0.3px;
}

.consent-btn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}

.consent-btn:active {
  transform: translateY(0);
}

.consent-btn-yes {
  background: #22c55e;
  color: #fff;
  border-color: #16a34a;
}

.consent-btn-no {
  background: #ef4444;
  color: #fff;
  border-color: #dc2626;
}

.voice-mode-btn--active {
  border-color: #c084fc;
  color: #a855f7;
}

.voice-mode-btn--listening {
  background: rgba(168, 85, 247, 0.1);
  animation: voice-pulse 1.5s ease-in-out infinite;
}

.voice-mode-btn--processing {
  background: rgba(251, 191, 36, 0.1);
  border-color: #fbbf24;
  color: #d97706;
}

.voice-mode-btn--speaking {
  background: rgba(52, 211, 153, 0.1);
  border-color: #34d399;
  color: #059669;
}

.voice-mode-btn--connecting {
  opacity: 0.6;
  animation: voice-pulse 1s ease-in-out infinite;
}

@keyframes voice-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(168, 85, 247, 0.4); }
  50% { box-shadow: 0 0 0 6px rgba(168, 85, 247, 0); }
}

.dark .voice-mode-btn--active {
  border-color: #a855f7;
  color: #c084fc;
}

.dark .voice-mode-btn--listening {
  background: rgba(168, 85, 247, 0.15);
}

.dark .voice-mode-btn--processing {
  background: rgba(251, 191, 36, 0.1);
  border-color: #d97706;
  color: #fbbf24;
}

.dark .voice-mode-btn--speaking {
  background: rgba(52, 211, 153, 0.1);
  border-color: #059669;
  color: #34d399;
}

@media (max-width: 768px) {
  .App:not(.App--single-column) .chat-input-container {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0.525rem 0.75rem;
    gap: 0.5rem;
  }

  .App:not(.App--single-column) .chat-overlay-stack {
    padding: 0 0.75rem;
  }

  .App:not(.App--single-column) .session-control-btn {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
  }

  .App:not(.App--single-column) .chat-input {
    flex: 1 1;
    min-width: 0;
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
  }

  .App:not(.App--single-column) .chat-input-shell {
    min-height: 36px;
  }

  .App:not(.App--single-column) .send-btn {
    width: 36px;
    height: 36px;
    min-height: 36px;
    flex-shrink: 0;
  }

  .App:not(.App--single-column) .llm-pause-container {
    padding: 0.5rem;
  }

  .App:not(.App--single-column) .llm-pause-btn {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatComposer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,yCAAyC;EACzC,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB;;sCAEoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,cAAc;EACd;;iCAE+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,8FAA8F;EAC9F,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;oCAEkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB;;oCAEkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB;;oCAEkC;AACpC;;AAEA;EACE,qBAAqB;EACrB;;sCAEoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;;qCAEmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF","sourcesContent":[".chat-bottom-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.chat-overlay-stack {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  pointer-events: none;\n  padding: 0 1.5rem;\n}\n\n.chat-overlay-stack--mode-collapsed {\n  gap: 0;\n}\n\n.chat-overlay-stack--consent-active {\n  gap: 0.45rem;\n}\n\n.composer-limit-warning {\n  pointer-events: none;\n  padding: 0.45rem 0.9rem;\n  border-radius: 999px;\n  border: 1px solid rgba(239, 68, 68, 0.42);\n  background: rgba(254, 226, 226, 0.96);\n  color: #b91c1c;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  box-shadow:\n    0 0 0 2px rgba(239, 68, 68, 0.12),\n    0 8px 20px rgba(239, 68, 68, 0.16);\n}\n\n.dark .composer-limit-warning {\n  border-color: rgba(248, 113, 113, 0.42);\n  background: rgba(76, 29, 29, 0.96);\n  color: #fecaca;\n  box-shadow:\n    0 0 0 2px rgba(248, 113, 113, 0.12),\n    0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.llm-pause-container {\n  pointer-events: none;\n  transform: translateY(-1.55rem);\n}\n\n.llm-pause-container--mode-collapsed {\n  transform: translateY(-0.95rem);\n}\n\n.App.App--single-column .llm-pause-container {\n  transform: translateY(0.8rem);\n}\n\n.App.App--single-column .llm-pause-container--mode-collapsed {\n  transform: translateY(1.1rem);\n}\n\n.llm-pause-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 1.05rem;\n  background: #ffffff;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;\n  pointer-events: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\n}\n\n.dark .llm-pause-btn {\n  background: #111827;\n  border-color: #374151;\n  color: #f9fafb;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);\n}\n\n.llm-pause-btn:hover {\n  background: #eff6ff;\n  border-color: #3b82f6;\n  color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.dark .llm-pause-btn:hover {\n  background: #1e3a8a;\n  border-color: #3b82f6;\n  color: #e5e7eb;\n}\n\n.llm-pause-btn:active {\n  transform: translateY(0);\n}\n\n.llm-pause-btn.paused {\n  background: #10b981;\n  color: #ffffff;\n  border-color: #059669;\n}\n\n.llm-pause-btn.paused:hover {\n  background: #059669;\n  transform: translateY(-1px);\n}\n\n.pause-icon {\n  width: 0.95rem;\n  height: 0.95rem;\n  flex: 0 0 auto;\n  display: block;\n}\n\n.pause-text {\n  font-size: 0.85rem;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.chat-input-container {\n  position: relative;\n  z-index: 11;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.875rem 1.5rem;\n  border-top: 1px solid #e5e7eb;\n  background: var(--surface-color);\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.chat-input-container.disabled-preview {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.dark .chat-input-container {\n  border-top-color: #374151;\n  background: #1f2937;\n}\n\n.chat-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n  padding: 0.875rem 1.25rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  border: 1px solid #d1d5db;\n  border-radius: 24px;\n  outline: none;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  background: var(--surface-color);\n  color: #1f2937;\n  resize: none;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.dark .chat-input {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.chat-input::placeholder {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-input:focus,\n.dark .chat-input:focus {\n  box-shadow: none;\n}\n\n.chat-input:disabled {\n  background-color: transparent;\n  cursor: not-allowed;\n}\n\n.dark .chat-input:disabled {\n  background-color: transparent;\n  color: #6b7280;\n}\n\n.chat-input-shell {\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 48px;\n  padding: 0 0.35rem 0 0;\n  border: 1px solid #d1d5db;\n  border-radius: 24px;\n  background: var(--surface-color);\n  transition: all 0.2s ease;\n}\n\n.chat-input-shell--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.dark .chat-input-shell {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.dark .chat-input-shell--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.chat-input-shell--limit-flash {\n  border-color: #ef4444;\n  background: #fee2e2;\n  box-shadow:\n    0 0 0 3px rgba(239, 68, 68, 0.24),\n    0 0 24px rgba(239, 68, 68, 0.22);\n}\n\n.dark .chat-input-shell--limit-flash {\n  border-color: #f87171;\n  background: #4c1d1d;\n  box-shadow:\n    0 0 0 3px rgba(248, 113, 113, 0.24),\n    0 0 24px rgba(248, 113, 113, 0.2);\n}\n\n.chat-input-shell:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.chat-input-shell--selection-cue:focus-within {\n  border-color: #2563eb;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.5),\n    0 0 34px rgba(59, 130, 246, 0.9);\n}\n\n.dark .chat-input-shell:focus-within {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.2);\n}\n\n.dark .chat-input-shell--selection-cue:focus-within {\n  border-color: #93c5fd;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.38),\n    0 0 32px rgba(96, 165, 250, 0.56);\n}\n\n.chat-input-shell--limit-flash:focus-within {\n  border-color: #dc2626;\n  box-shadow:\n    0 0 0 3px rgba(239, 68, 68, 0.28),\n    0 0 28px rgba(239, 68, 68, 0.24);\n}\n\n.dark .chat-input-shell--limit-flash:focus-within {\n  border-color: #fca5a5;\n  box-shadow:\n    0 0 0 3px rgba(248, 113, 113, 0.28),\n    0 0 28px rgba(248, 113, 113, 0.22);\n}\n\n.chat-input-shell:has(.chat-input:disabled) {\n  background-color: #f9fafb;\n}\n\n.dark .chat-input-shell:has(.chat-input:disabled) {\n  background-color: #374151;\n}\n\n.chat-input-shell .chat-input {\n  border: none;\n  border-radius: 18px;\n  background: transparent;\n  min-width: 0;\n  width: 100%;\n  min-height: 1.5em;\n  max-height: calc(1.5em * 3 + 1.75rem);\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n}\n\n.keyboard-btn {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 36px;\n  align-self: center;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: var(--surface-color);\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dark .keyboard-btn {\n  background: #374151;\n  border-color: #4b5563;\n  color: #d1d5db;\n}\n\n.keyboard-btn:hover {\n  transform: translateY(-1px);\n  background: #f3f4f6;\n  border-color: #94a3b8;\n}\n\n.dark .keyboard-btn:hover {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.keyboard-btn:disabled {\n  cursor: not-allowed;\n  opacity: 1;\n  transform: none;\n  background: #f9fafb;\n  border-color: #d1d5db;\n  color: #9ca3af;\n}\n\n.keyboard-btn:disabled:hover {\n  transform: none;\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.dark .keyboard-btn:disabled {\n  background: #374151;\n  border-color: #4b5563;\n  color: #6b7280;\n}\n\n.dark .keyboard-btn:disabled:hover {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.keyboard-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.16);\n}\n\n.keyboard-icon {\n  width: 16px;\n  height: 16px;\n}\n\n.send-btn {\n  padding: 0.875rem 2rem;\n  min-height: 48px;\n  align-self: center;\n  background: #2563eb;\n  color: #f0f9ff;\n  border: 1px solid #1d4ed8;\n  border-radius: 24px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  box-shadow: none;\n}\n\n.dark .send-btn {\n  background: #2563eb;\n  border-color: #1e3a8a;\n  color: #e0f2fe;\n  box-shadow: none;\n}\n\n.send-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: none;\n}\n\n.dark .send-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: none;\n}\n\n.send-btn:disabled {\n  background: #cbd5f5;\n  border-color: #b4c3f0;\n  color: #6b7280;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.dark .send-btn:disabled {\n  background: #1f2937;\n  border-color: #374151;\n  color: #4b5563;\n}\n\n.send-icon {\n  display: block;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n  transition: transform 0.2s ease;\n}\n\n.send-btn:hover:not(:disabled) .send-icon {\n  transform: translateX(2px);\n}\n\n.send-btn--compact-inside {\n  display: none;\n}\n\n@media (max-width: 1067px) {\n  .keyboard-btn {\n    display: none;\n  }\n\n  .send-btn--desktop {\n    display: none;\n  }\n\n  .send-btn--compact-inside {\n    display: inline-flex;\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n    min-height: 34px;\n    padding: 0;\n    border-radius: 18px;\n    align-self: center;\n  }\n\n  .send-btn--compact-inside .send-icon {\n    width: 15px;\n    height: 15px;\n  }\n\n  .send-btn--compact-inside:hover:not(:disabled) {\n    transform: none;\n  }\n\n  .send-btn--compact-inside:hover:not(:disabled) .send-icon {\n    transform: translateX(1px);\n  }\n}\n\n.App.App--single-column .chat-input-container {\n  padding: 0.475rem 0.9rem;\n  gap: 0.55rem;\n}\n\n.App.App--single-column .chat-input-shell {\n  min-height: 40px;\n  border-radius: 20px;\n}\n\n.App.App--single-column .chat-input-shell .chat-input {\n  font-size: 16px;\n  padding-top: 0.56rem;\n  padding-bottom: 0.56rem;\n  line-height: 1.42;\n}\n\n.App.App--single-column .session-controls-compact__trigger {\n  height: 40px;\n}\n\n.App.App--single-column .send-btn--compact-inside {\n  width: 30px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.App.App--single-column .send-btn--compact-inside .send-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.session-controls-compact {\n  position: relative;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n}\n\n.session-controls-compact__trigger {\n  width: 1rem;\n  min-width: 1rem;\n  height: 48px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  color: #64748b;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.18rem;\n  padding: 0;\n  cursor: pointer;\n  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\n.session-controls-compact__trigger:hover {\n  background: transparent;\n  border-color: transparent;\n  color: #334155;\n}\n\n.session-controls-compact__dot {\n  width: 3px;\n  height: 3px;\n  border-radius: 999px;\n  background: currentColor;\n}\n\n.session-controls-compact__menu {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 0.45rem);\n  width: 10.5rem;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: var(--surface-color);\n  box-shadow: none;\n  z-index: 30;\n}\n\n.session-controls-compact__item {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #374151;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.62rem 0.75rem;\n  font-family: inherit;\n  font-size: 0.84rem;\n  font-weight: 650;\n  text-align: left;\n}\n\n.session-controls-compact__item .control-icon {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n}\n\n.session-controls-compact__item:hover:not(:disabled),\n.session-controls-compact__item.active {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.session-controls-compact__item:disabled {\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.dark .session-controls-compact__trigger {\n  background: transparent;\n  border-color: transparent;\n  color: #94a3b8;\n}\n\n.dark .session-controls-compact__trigger:hover {\n  background: transparent;\n  border-color: transparent;\n  color: #e2e8f0;\n}\n\n.dark .session-controls-compact__menu {\n  background: #1f2937;\n  border-color: #4b5563;\n}\n\n.dark .session-controls-compact__item {\n  color: #d1d5db;\n}\n\n.dark .session-controls-compact__item:hover:not(:disabled),\n.dark .session-controls-compact__item.active {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.dark .session-controls-compact__item:disabled {\n  color: #6b7280;\n}\n\n.session-control-btn {\n  padding: 0.875rem 1rem;\n  background: #e5e7eb;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 20px;\n  font-size: 1.25rem;\n  font-weight: normal;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n}\n\n.dark .session-control-btn {\n  background: #374151;\n  color: #f9fafb;\n  border-color: #4b5563;\n}\n\n.session-control-btn:hover:not(:disabled) {\n  background: #cbd5e1;\n  border-color: #94a3b8;\n}\n\n.dark .session-control-btn:hover:not(:disabled) {\n  background: #4b5563;\n  border-color: #6b7280;\n}\n\n.session-control-btn:disabled {\n  background: #f3f4f6;\n  color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dark .session-control-btn:disabled {\n  background: #1f2937;\n  color: #4b5563;\n  border-color: #374151;\n}\n\n.control-icon {\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n  transition: transform 0.2s ease;\n}\n\n.session-control-btn:hover:not(:disabled) .control-icon {\n  transform: translateY(-1px);\n}\n\n.consent-container {\n  pointer-events: none;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  transform: translateY(-0.35rem);\n}\n\n.consent-panel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.85rem;\n  background: #ffffff;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  pointer-events: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\n  white-space: nowrap;\n}\n\n.dark .consent-panel {\n  background: #111827;\n  border-color: #374151;\n  color: #f9fafb;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.25);\n}\n\n.consent-panel--selection-cue {\n  border-color: #3b82f6;\n  background: #dbeafe;\n  box-shadow:\n    0 0 0 3px rgba(59, 130, 246, 0.42),\n    0 0 30px rgba(59, 130, 246, 0.82);\n}\n\n.dark .consent-panel--selection-cue {\n  border-color: #60a5fa;\n  background: #1e3a5f;\n  box-shadow:\n    0 0 0 3px rgba(96, 165, 250, 0.3),\n    0 0 28px rgba(96, 165, 250, 0.44);\n}\n\n.consent-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.dark .consent-label {\n  color: #9ca3af;\n}\n\n.consent-divider {\n  width: 1px;\n  height: 1.1rem;\n  background: #e5e7eb;\n  margin: 0 0.25rem;\n}\n\n.dark .consent-divider {\n  background: #374151;\n}\n\n.consent-btn {\n  padding: 0.3rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  letter-spacing: 0.3px;\n}\n\n.consent-btn:hover {\n  opacity: 0.85;\n  transform: translateY(-1px);\n}\n\n.consent-btn:active {\n  transform: translateY(0);\n}\n\n.consent-btn-yes {\n  background: #22c55e;\n  color: #fff;\n  border-color: #16a34a;\n}\n\n.consent-btn-no {\n  background: #ef4444;\n  color: #fff;\n  border-color: #dc2626;\n}\n\n.voice-mode-btn--active {\n  border-color: #c084fc;\n  color: #a855f7;\n}\n\n.voice-mode-btn--listening {\n  background: rgba(168, 85, 247, 0.1);\n  animation: voice-pulse 1.5s ease-in-out infinite;\n}\n\n.voice-mode-btn--processing {\n  background: rgba(251, 191, 36, 0.1);\n  border-color: #fbbf24;\n  color: #d97706;\n}\n\n.voice-mode-btn--speaking {\n  background: rgba(52, 211, 153, 0.1);\n  border-color: #34d399;\n  color: #059669;\n}\n\n.voice-mode-btn--connecting {\n  opacity: 0.6;\n  animation: voice-pulse 1s ease-in-out infinite;\n}\n\n@keyframes voice-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(168, 85, 247, 0.4); }\n  50% { box-shadow: 0 0 0 6px rgba(168, 85, 247, 0); }\n}\n\n.dark .voice-mode-btn--active {\n  border-color: #a855f7;\n  color: #c084fc;\n}\n\n.dark .voice-mode-btn--listening {\n  background: rgba(168, 85, 247, 0.15);\n}\n\n.dark .voice-mode-btn--processing {\n  background: rgba(251, 191, 36, 0.1);\n  border-color: #d97706;\n  color: #fbbf24;\n}\n\n.dark .voice-mode-btn--speaking {\n  background: rgba(52, 211, 153, 0.1);\n  border-color: #059669;\n  color: #34d399;\n}\n\n@media (max-width: 768px) {\n  .App:not(.App--single-column) .chat-input-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 0.525rem 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .App:not(.App--single-column) .chat-overlay-stack {\n    padding: 0 0.75rem;\n  }\n\n  .App:not(.App--single-column) .session-control-btn {\n    width: 36px;\n    height: 36px;\n    flex-shrink: 0;\n  }\n\n  .App:not(.App--single-column) .chat-input {\n    flex: 1;\n    min-width: 0;\n    font-size: 0.9rem;\n    padding: 0.5rem 0.75rem;\n  }\n\n  .App:not(.App--single-column) .chat-input-shell {\n    min-height: 36px;\n  }\n\n  .App:not(.App--single-column) .send-btn {\n    width: 36px;\n    height: 36px;\n    min-height: 36px;\n    flex-shrink: 0;\n  }\n\n  .App:not(.App--single-column) .llm-pause-container {\n    padding: 0.5rem;\n  }\n\n  .App:not(.App--single-column) .llm-pause-btn {\n    font-size: 0.8rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
